module.exports = __webpack_public_path__ + "72d7455d78fde71a2c9da597e9ff45d5.svg";